import React, {useEffect} from "react";
import PaginatedDataTable from "../../../../components/table/PaginatedDataTable";
import { useGetPublicationsExtractQuery } from "../../../../redux/service/modules/dashboard";
import { useSelector } from "react-redux";
import Sectors from "../../../../components/table/Sectors";
import TableLayout from "../../../../components/layout/TableLayout";

const PublishedReports = ({ appliedFilters, setRequiredFilters }) => {
  const dateRange = useSelector((state) => state.date);

  useEffect(() => {
    setRequiredFilters(['analyst', 'sector', 'report_type'])
  }, [setRequiredFilters])

  const customCellRender = {
    sectors: (row) => {
      let sectorList = row?.sectors || []
      if(typeof sectorList === 'string') {
        if(sectorList.includes(';')) {
          sectorList = sectorList.split(';')
        } else if(sectorList.includes(',')) {
          sectorList = sectorList.split(',')
        } else {
          sectorList = [sectorList]
        }
      }
      return <Sectors sectors={sectorList} maxVisible={1}/>
    },
    tagged_stocks: (row) => {
      let stockList = row?.tagged_stocks || []
      return <Sectors title="Instrument" sectors={stockList} maxVisible={1}/>
    }
  }

  const validFilters = {
    ...appliedFilters,
    initialDateRange: dateRange,
  }

  return (
    <TableLayout>
      <PaginatedDataTable
        queryHook={useGetPublicationsExtractQuery}
        initialDateRange={dateRange}
        appliedFilters={validFilters}
        firstColumnWidth="100px"
        alignItems="left"
        customCellRender={customCellRender}
      />
    </TableLayout>
  );
};

export default PublishedReports;
